// import { getTagsByPost } from '@lib/wordpress';
import { WEB_LINK } from '@common/constants';
import { Category, Post, Tag } from '@lib/wordpress.d';
import { HOME_ROUTES } from '@util/constants';

type Props = {
  post: Post;
};
export const GetPostTitle = ({ post }: Props) => (
  <div
    dangerouslySetInnerHTML={{
      __html: post.title.rendered,
    }}></div>
);

export const GetPostDetails = ({ post }: Props) => (
  <div
    dangerouslySetInnerHTML={{
      __html:
        post.excerpt.rendered.split(' ').slice(0, 12).join(' ').trim() + '...',
    }}></div>
);

export const getPostSubmitted = ({ post }: Props) => {
  const date = new Date(post?.date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  return date;
};

export const getPostReadTime = ({ post }: Props) => {
  return post?.yoast_head_json?.twitter_misc?.['Est. reading time'];
};

export const getPostAuthor = ({ post }: Props) => {
  return post?.yoast_head_json?.twitter_misc?.['Written by'];
};

export const getPostFeaturedMedia = ({ post }: Props) => {
  return post?.yoast_head_json?.og_image?.[0]?.url;
};

type TagProps = {
  categoryIds: number[];
  categories: Category[];
  style: string;
};
export const GetPostCategories = ({
  categoryIds,
  categories,
  style,
}: TagProps) => {
  return categories.map((category: Category) => {
    if (!categoryIds.includes(category.id)) return null;
    return (
      <span
        className={style}
        key={category.id}
        dangerouslySetInnerHTML={{
          __html: category.name,
        }}
      />
    );
  });
};

export const getPostTagByPostId = ({ tags, style }: any) => {
  return tags?.map((tag: Tag) => {
    return (
      <span
        className={style}
        key={tag.id}
        dangerouslySetInnerHTML={{
          __html: tag.name,
        }}
      />
    );
  });
};

export const GetPostTags = ({ tags, tagIds, style, getSelectedTag }: any) => {
  return tags?.map((tag: Tag) => {
    if (!tagIds.includes(tag.id)) return null;
    return (
      <span
        className={style}
        onClick={(clickEvent) => getSelectedTag(clickEvent, tag)}
        key={tag.id}
        dangerouslySetInnerHTML={{
          __html: tag.name,
        }}
      />
    );
  });
};

export const getSEOPostTitle = ({ post }: Props) => {
  return post?.yoast_head_json?.og_title;
};

export const getSEOPostDesc = ({ post }: Props) => {
  return post?.yoast_head_json?.description;
};

export const getSEOPostCanonical = ({ post }: Props) => {
  return WEB_LINK + HOME_ROUTES.BLOG_DETAILS + post.slug;
};
